import { foundation } from "@teaming/slice-engine";
import { alertFactory } from "@teaming/common-ui";

export default function hostInboxStoreFactory() {
	const { store, i18n, config, ioInbox, } = foundation();

	if ( store.hasModule( "inbox" ) ) {
		return;
	}
	const { error, } = alertFactory( "teaming-web.store.host-teamless-inbox", i18n.global.t );


	return store.registerModule( "inbox", {
		namespaced: true,
		state: {
			loadingTeamlessMeetings: false,
			teamlessMeetings: [],
			teamChoices: [],
			featureFlag: config.teamlessInboxFeatureFlag,
		},
		getters: {
			teamlessMeetingsBadgeCount( state ) {
				return state.teamlessMeetings.filter( mtg => !mtg.teamId ).length;
			},
		},
		mutations: {
			setLoading( state, loading ) {
				state.loadingTeamlessMeetings = loading;
			},
			setTeamlessMeetings( state, meetings ) {
				state.teamlessMeetings = meetings;
			},
			setTeamChoices( state, teamChoices ) {
				state.teamChoices = teamChoices;
			},
			setMeetingTeam( state, { team, meetingId, } ) {
				const meeting = state.teamlessMeetings.find( mtg => mtg.id === meetingId );
				if ( meeting ) {
					meeting.teamId = team?.id || null;
					meeting.team = team || null;
				}
			},
		},
		actions: {
			async tryFetchTeamlessMeetings( { state, commit, }, { participants = false, } = {} ) {
				// called on TeamlessInboxHOC mount with participants,
				// and for inbox nav-item without participants.
				if ( !state.loadingTeamlessMeetings ) {
					try {
						commit( "setLoading", true );
						const teamlessMeetings = await ioInbox.fetchTeamlessMeetings( participants );
						commit( "setTeamlessMeetings", teamlessMeetings );
						commit( "setLoading", false );
					} catch ( e ) {
						error( "errorLoadingTeamlessMeetings" );
						commit( "setLoading", false );
					}
				}
			},
			async tryFetchTeamChoices( { state, commit, } ) {
				// called on TeamlessInboxHOC mount
				if ( !state.loadingTeamChoices ) {
					try {
						const teamChoices = await ioInbox.fetchTeamChoices();
						commit( "setTeamChoices", teamChoices );
					} catch ( e ) {
						error( "errorLoadingTeamChoices" );
					}
				}
			},
			async assignTeamToMeeting( { commit, }, { team, meeting, } ) {
				commit( "setMeetingTeam", { team, meetingId: meeting.id, } );
				try {
					await ioInbox.updateTeamlessMeeting( meeting.id, { teamId: team.id, } );
				} catch ( e ) {
					// rollback
					commit( "setMeetingTeam", { team: null, meetingId: meeting.id, } );
					error( "errorAssigningTeam" );
				}
			},
			async unassignTeamFromMeeting( { commit, }, meeting ) {
				// TODO-W https://mine.leankit.com/card/2103532843
				// eslint-disable-next-line no-console
				console.warn( "Warning: unassignTeamFromMeeting has been called. Unless TODO ticket has been completed, this will result in weirdness." );
				commit( "setMeetingTeam", { team: null, meetingId: meeting.id, } );
				try {
					await ioInbox.updateTeamlessMeeting( meeting.id, { teamId: null, } );
				} catch ( e ) {
					// rollback
					commit( "setMeetingTeam", { team: meeting.team, meetingId: meeting.id, } );
					error( "errorUnassigningTeam" );
				}
			},
		},
	} );
}
